import Card from 'react-bootstrap/Card'
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginImagePreview)

export default class FileUploader extends React.Component { 
	static defaultProps = { 
		title: "Upload photo",
		acceptedFileTypes: ['image/png', 'image/jpeg'],
		validateSize: true,
		maxSize: "2MB"
	}

	handleFileSelect(fileItems) { 
		const files = fileItems.map(fileItem => fileItem.file)
		this.props.onChange(files)
	}

	render() { 
		return (	<React.Fragment>
				    <Card.Title>{this.props.title}</Card.Title>
				    <p>{this.props.subtitle !== undefined && this.props.subtitle}</p>	
				    <p><small>{this.props.hint !== undefined && this.props.hint}</small></p>
				        <div>
				        <FilePond
				         disabled={this.props.disabled}
				         className="file-upload"
				         acceptedFileTypes={this.props.acceptedFileTypes}
				         allowFileSizeValidation={this.props.validateSize}
				         maxFileSize={this.props.maxSize}
				         onupdatefiles={fileItems => this.handleFileSelect(fileItems)}/>
				    </div>
				    </React.Fragment>
			)
	}
}